import marked from 'marked'
import { type } from 'os'
import Vue, { VNode } from 'vue'

interface LocalizedObject {
  byLanguage: {
    [key: string]: string | undefined
  }
}

export default Vue.extend({
  computed: {
    currentLanguage(): string {
      return this.locale || this.$i18n.locale
    },
    content(): string {
      if (typeof this.translate === 'string') {
        return this.translate
      } else if (typeof this.translate === 'object' && this.translate.byLanguage) {
        return this.translate.byLanguage[this.currentLanguage] || this.default
      } else {
        return this.default
      }
    },
    formatted(): string {
      if (this.content.indexOf('\n\n') >= 0 || this.content.indexOf('\r\n\r\n') >= 0) {
        return marked(this.content)
      } else {
        return marked.inlineLexer(this.content, [])
      }
    },
  },
  props: {
    default: {
      default: 'missing translation',
      type: String,
    },
    locale: {
      type: String,
    },
    tag: {
      default: 'div',
      type: String,
    },
    translate: {
      required: true,
      type: [String, Object as () => LocalizedObject],
      validator(value: string | LocalizedObject): boolean {
        if (typeof value === 'string') {
          return true
        } else {
          return !!value.byLanguage
        }
      },
    },
  },
  render(h): VNode {
    const Tag = this.tag
    return (
      <Tag
        {...{ attrs: this.$attrs, on: this.$listeners, domProps: { innerHTML: this.formatted } }}
      />
    )
  },
})
